var exports = {
  "N4": "SubscriptionCard.module__note___N0w1VG",
  "o1": "SubscriptionCard.module__actions___N0w1VG",
  "H2": "SubscriptionCard.module__legacyRateBadge___N0w1VG",
};

module.exports = exports;
